import React from 'react';
import Hero from '../../components/Hero/Hero copy';
import HomeAbout from '../../components/About/About';
import HomeCountries from '../../components/Countries/Countries';
import HomeNews from '../../components/News/News';

const Home = () => {
  return (
    <div>
      <Hero />
      <HomeAbout />
      <HomeCountries />
      <HomeNews />
    </div>
  );
};

export default Home;
